import { Component, ElementRef, OnInit, Renderer2, ViewEncapsulation, inject } from '@angular/core';
import { Router} from '@angular/router';
import { environment } from './../environments/environment';
import { quickWebLogger } from '@quickweb/logger';
import { applySegmentToElement } from "@ids/tools";
import { Segments } from '@ids/tools';
import { NotificacaoService } from './abertura-conta/config/service/notificacao/notificacao.service';
import { AnalyticsService } from './shared/services/analytics/analytics.service';
@Component({
  selector: 'app-mfe-abertura-conta-agro',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  encapsulation: ViewEncapsulation.ShadowDom,
})
export class AppComponent implements OnInit {

  private readonly _elementRef: ElementRef<HTMLElement> = inject(ElementRef);
  private readonly _renderer = inject(Renderer2);
  public readonly _router = inject(Router);
  public readonly notificacaoService = inject(NotificacaoService);
  private readonly analyticsService = inject(AnalyticsService);
  selector = 'app-mfe-abertura-conta-agro';

  constructor() {
  }

  ngOnInit() {
    this._injectRootStyles();
    this._router.initialNavigation();
    this.initDataDog();
    this.analyticsService.init();
    applySegmentToElement(Segments.Itau_bba, "app-mfe-abertura-conta-agro");


    this.remocaoLoadingNF2();
  }

  public initDataDog(): void {
    if (environment.logConfig)
      quickWebLogger.init(environment.logConfig);
  }

  /**
   * Workaround para estilos aplicados no selector `root`,
   * como variáveis CSS nativas e `@font-face` que infelizmente
   * não funcionam com `Shadow DOM` a não ser injetando manualmente
   * no elemento que envolve o `shadowRoot`.
   *
   * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/Web_components/Using_shadow_DOM|Shadow DOM}
   * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/ShadowRoot|ShadowRoot}
   */
  private _injectRootStyles(): void {
    const linkElement: HTMLLinkElement = this._renderer.createElement('link');
    this._renderer.setAttribute(linkElement, 'rel', 'stylesheet');

    const dynamicInjectionStylesPath = environment.baseHref + 'styles.css';
    this._renderer.setAttribute(linkElement, 'href', dynamicInjectionStylesPath);

    this._elementRef.nativeElement.appendChild(linkElement);

  }


  remocaoLoadingNF2(): void {
    try {
      const intervalId = window.setIntervalLoaderCountDown;
      if (typeof intervalId === 'number') {
        clearInterval(intervalId);
      }
    } catch (e) {
      console.error('Erro ao remover contagem regressiva do loader:', e);
    }

    try {
      const style = document.createElement('style');
      style.innerHTML = `
      #divGif,
      .blockUI,
      .loading-nova-internet {
        display: none !important;
        visibility: hidden !important;
        opacity: 0 !important;
      }
    `;
      document.head.appendChild(style);
      setTimeout(() => {
        document.getElementsByTagName("title")[0].innerHTML = "Abertura de Conta Agro";
        this._setFavicon();
      }, 2000);
    } catch (e) {
      console.error('Erro ao injetar CSS anti-loading:', e);
    }
  }

  private _setFavicon(): void {
    // Remove favicon existente para evitar duplicatas
    const existingFavicon = document.querySelector("link[rel='icon']");
    if (existingFavicon) {
      this._renderer.removeChild(document.head, existingFavicon);
    }

    const favicon: HTMLLinkElement = this._renderer.createElement('link');
    this._renderer.setAttribute(favicon, 'rel', 'icon');
    this._renderer.setAttribute(favicon, 'type', 'image/x-icon');
    this._renderer.setAttribute(favicon, 'href', `${environment.baseHref}seguro_agricola_outline.svg`);
    this._renderer.appendChild(document.head, favicon);
  }
}
 